/** Часть узла: задаёт AAD шифра, чтобы шифротекст места нельзя было подставить в данные */
export enum EnumLibrePart {
  PLACE = 'place',
  DATA = 'data',
}
